"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _RetailBuySell = require("../../../components/Retail/RetailBuySell");
var _RecentActivityContainer = _interopRequireDefault(require("../../../components/RecentActivity/RecentActivityContainer"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./BuySellMobileLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var classes = (0, _cssClassesHelper.getBEMClasses)('buy-sell-alt-mobile-layout');
var BuySellMobileLayout = function BuySellMobileLayout() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('content-wrapper')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('select-instument-container')
  }, /*#__PURE__*/_react["default"].createElement(_RetailBuySell.BuySellInstrumentSelectContainer, null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('make-transaction-container')
  }, /*#__PURE__*/_react["default"].createElement(_RetailBuySell.BuySellMakeTransactionContainer, {
    themeModifier: "layout-style-2",
    displayInstrumentSelector: false
  }, /*#__PURE__*/_react["default"].createElement(_RetailBuySell.BuySellContainer, {
    extraInfoComponent: /*#__PURE__*/_react["default"].createElement(_RetailBuySell.BuySellOrderOverviewContainer, {
      customClass: "compacted"
    })
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('recent-orders-container')
  }, /*#__PURE__*/_react["default"].createElement(_RecentActivityContainer["default"], {
    filterForSelected: false,
    useAdvancedVersion: false,
    headerText: "Recent Orders",
    themeModifier: "no-product-icon"
  }))));
};
var _default = exports["default"] = BuySellMobileLayout;